module.exports = __webpack_public_path__ + "img/charity-event-campaign.2a3a7bdb.jpg";